import { ColDef } from 'ag-grid-community'

const dateColumn: ColDef = {
  field: 'date',
  headerName: 'Date',
  flex: 1,
  minWidth: 180,
  filter: false, // Disable filtering, keep sorting
  valueFormatter: params => {
    if (!params.value) return ''
    return new Date(params.value).toLocaleString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  },
}

// BackOffice column definitions
export const getBackOfficeLogsColumnDefs = (): ColDef[] => [
  {
    field: 'user',
    headerName: 'User',
    flex: 1,
    minWidth: 150,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'contains', 'startsWith', 'endsWith', 'notEqual', 'notContains'],
      defaultOption: 'contains',
    },
    valueGetter: params => {
      if (!params.data?.user) return ''
      const user = params.data.user
      return `${user.firstname} ${user.lastname}`.trim()
    },
    filterValueGetter: params => {
      if (!params.data?.user) return ''
      const user = params.data.user
      return `${user.firstname} ${user.lastname}`.trim()
    },
  },
  {
    field: 'event',
    headerName: 'Action',
    flex: 1,
    minWidth: 200,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'contains', 'startsWith', 'endsWith', 'notEqual', 'notContains'],
      defaultOption: 'contains',
    },
  },
  {
    field: 'dbCollection',
    headerName: 'Collection DB',
    flex: 1,
    minWidth: 150,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'contains', 'startsWith', 'endsWith', 'notEqual', 'notContains'],
      defaultOption: 'contains',
    },
  },
  {
    field: 'rowId',
    headerName: 'ID Ressource',
    flex: 1,
    minWidth: 150,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'contains', 'startsWith', 'endsWith', 'notEqual', 'notContains'],

    },
    valueFormatter: params => {
      if (!params.value) return ''
      return String(params.value)
    },
  },
  dateColumn,
]

// Client column definitions
export const getClientLogsColumnDefs = (): ColDef[] => [
  {
    field: 'client',
    headerName: 'Client',
    flex: 1,
    minWidth: 150,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'contains', 'startsWith', 'endsWith', 'notEqual', 'notContains'],
      defaultOption: 'contains',
    },
    valueGetter: params => {
      if (!params.data?.client) return ''
      return (
        params.data.client.name ||
        `${params.data.client.firstname} ${params.data.client.lastname}`.trim()
      )
    },
    filterValueGetter: params => {
      if (!params.data?.client) return ''
      const client = params.data.client
      return `${client.name} ${client.firstname} ${client.lastname} ${client.email}`.trim()
    },
  },
  {
    field: 'operationType',
    headerName: "Type d'opération",
    flex: 1,
    minWidth: 150,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [], // Will be populated from data
    },
  },
  {
    field: 'cardSerialNumber',
    headerName: 'Numéro de série de la carte',
    flex: 1,
    minWidth: 150,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'contains', 'startsWith', 'endsWith'],
      defaultOption: 'equals',
    },
  },
  {
    field: 'cardType',
    headerName: 'Type de carte',
    flex: 1,
    minWidth: 120,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [], // Will be populated from data
    },
  },
  {
    field: 'cardVariant',
    headerName: 'Variante de carte',
    flex: 1,
    minWidth: 120,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [], // Will be populated from data
    },
  },
  {
    field: 'isSuccess',
    headerName: 'Succès',
    flex: 1,
    minWidth: 100,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: ['Oui', 'Non'],
    },
    filterValueGetter: params => {
      if (params.data?.isSuccess === undefined || params.data?.isSuccess === null) return ''
      return params.data.isSuccess ? 'Oui' : 'Non'
    },
    valueFormatter: params => {
      if (params.value === undefined || params.value === null) return ''
      return params.value ? 'Oui' : 'Non'
    },
  },
  {
    field: 'errorMessage',
    headerName: "Message d'erreur",
    flex: 2,
    minWidth: 200,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'contains', 'startsWith', 'endsWith', 'notEqual', 'notContains'],
      defaultOption: 'contains',
    },
  },
  dateColumn,
]

// Legacy export for backward compatibility
export const getActivityLogsColumnDefs = (): ColDef[] => {
  return getBackOfficeLogsColumnDefs()
}
